module.exports = function(data) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }

 if (data.state.violations.length) { ;
__p += '\n<div class="pz-alert alert alert-danger clearfix" role="alert">\n    <div class="triangle-icon"><i class="far fa-exclamation-triangle"></i></div>\n    <div class="alert-message">' +
((__t = ( data.state.violations.join("<br/><br/>") )) == null ? '' : __t) +
'</div>\n</div>\n';
 } ;
__p += '\n\n<form class="form-horizontal">\n    <div class="report-name-group">\n        <label for="name" class="control-label">' +
((__t = ( strings.reports_name )) == null ? '' : __t) +
'</label>\n        <input type="text" class="form-control" placeholder="' +
((__t = ( data.name_placeholder )) == null ? '' : __t) +
'" id="name" value="' +
((__t = ( data.name )) == null ? '' : __t) +
'">\n    </div>\n    <div class="dates-header">' +
((__t = ( strings.reports_date_caption )) == null ? '' : __t) +
'</div>\n    <div class="dates-ranges">\n        ';
 data.ranges.forEach(function(r, i) { ;
__p += '\n        <label>\n            <input type="radio" name="dateRadios" id="dates" value="' +
((__t = ( r.value )) == null ? '' : __t) +
'" ' +
((__t = ( r.value === data.state.selected_daterange && "checked")) == null ? '' : __t) +
'>\n            ' +
((__t = ( r.label )) == null ? '' : __t) +
'\n        </label>\n        ';
 }) ;
__p += '\n    </div>\n</form>\n';
return __p
}